import {STORAGE_STATE_KEY as storageKey} from 'shared/const';
import {STORAGE_BACKUP_KEY as backupKey} from './const';
import {storageProxy} from 'interactors/storageProxy';

export function backup(storage: StorageService = storageProxy): void {
  const data = storage.getItem(storageKey);
  storage.setItem(backupKey, data);
}
